export default __webpack_public_path__ + "static/media/2 (3000).174db0fe.jpg";